import * as React from 'react';
import { connect } from 'react-redux';
import store from '@/redux/store';
import '@/assets/scss/component/languageChange.scss';
import { setLocalStorage } from '@/utils/utils';

interface InterState {
  isShowChoose: boolean,
}

class LanguageChange extends React.Component<any, InterState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isShowChoose: false,
    };
  }

  public componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    // window.scrollTo(0, 200);
  }

  // 监听页面
  public handleScroll() {
    setTimeout(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      setLocalStorage('scrollTop', scrollTop);
    }, 1000);
  }

  public openLangChoose() {
    this.setState({
      isShowChoose: !this.state.isShowChoose,
    });
  }

  public render() {
    const { state, changeLang } = this.props;
    return (
      <ul className="language-content" style={{ display: 'none' }}>  // 隐藏语言切换按钮
        <li
          onClick={ () => { changeLang('zh-CN') } }
          className={ this.state.isShowChoose ? 'language-button' : 'language-button none' }>
          简
        </li>
        <li
          onClick={ () => { changeLang('zh-TW') } }
          className={ this.state.isShowChoose ? 'language-button' : 'language-button none' }>
          繁
        </li>
        <li
          onClick={ () => { this.openLangChoose() } }
          className={ store.getState().changeLang.lang === 'zh-CN' ? 'language-button active' : 'language-button none' }>
          简
        </li>
        <li
          onClick={ () => { this.openLangChoose() } }
          className={ store.getState().changeLang.lang === 'zh-TW' ? 'language-button active' : 'language-button none' }>
          繁
        </li>
      </ul>
    )
  }
}

function mapStateToProps(state) {
  return {
    state,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeLang(lang: any) {
      store.dispatch({ type: 'CHANGE_LANG', lang: lang });
      setLocalStorage('language', lang);
      location.reload(false);
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LanguageChange);
